/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react'
import {
  Button,
  Card,
  ListItemButton,
  ListItemText,
  Typography,
  Box,
  Tooltip,
} from '@mui/material'
import IconEntry from '~/components/IconsSvg/entry'
import { useLang } from '~/hooks/useLang'

import { useHistory } from 'react-router-dom'
import useUserState from '~/features/User/stores/UserState'
import { MenuProps } from '../../interfaces'

export default function EntryMenu({ activeMenu, handleMenuClick }: MenuProps) {
  const { translate } = useLang()
  const { verifyPermission } = useUserState()

  const history = useHistory()

  return (
    <>
      {verifyPermission(['entry_index', 'entry_dashboard']) && (
        <Box>
          <Tooltip title={translate('Entry')} placement="bottom">
            <Button
              className={`main-menu ${activeMenu == 'entry' ? 'active' : ''}`}
              onClick={() => handleMenuClick('entry')}
            >
              <IconEntry />
            </Button>
          </Tooltip>
          <Card
            className="submenu-box"
            sx={{
              borderRadius: 0,
              display: activeMenu == 'entry' ? 'block' : 'none',
            }}
          >
            <Typography variant="h4" sx={{ textAlign: 'center' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  gap: 1,
                }}
              >
                <IconEntry />
                {translate('Entry')}
              </Box>
            </Typography>

            {verifyPermission(['entry_index']) && (
              <Tooltip
                title={translate('Create new entry screen')}
                placement="right"
              >
                <ListItemButton
                  onClick={() => {
                    handleMenuClick('entry')
                    history.push('/entry')
                  }}
                >
                  <ListItemText primary={translate('Entry')} />
                </ListItemButton>
              </Tooltip>
            )}

            {verifyPermission(['entry_dashboard']) && (
              <Tooltip
                title={translate('Information about entry')}
                placement="right"
              >
                <ListItemButton
                  onClick={() => {
                    handleMenuClick('entry')
                    history.push('/entry/dashboard')
                  }}
                >
                  <ListItemText primary={translate('Management Entry')} />
                </ListItemButton>
              </Tooltip>
            )}
            {verifyPermission(['entry_overview']) && (
              <Tooltip
                title={translate('Information about stations')}
                placement="right"
              >
                <ListItemButton
                  onClick={() => {
                    handleMenuClick('entry')
                    history.push('/entry/management/stations')
                  }}
                >
                  <ListItemText primary={translate('Management Stations')} />
                </ListItemButton>
              </Tooltip>
            )}
          </Card>
        </Box>
      )}
    </>
  )
}
